import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { userActions } from '../../_actions';
import './login.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from '../../images/OPPTIMISE_logo.png';



class LoginPage extends React.Component {
    constructor(props) {
        super(props);


        this.props.dispatch(userActions.logout());

        this.state = {
            email: '',
            password: '',
            submitted: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        localStorage.clear();

        const queryParams = new URLSearchParams(window.location.search);
        const auth_key = queryParams.get('auth_key');

        if (auth_key) {
            const authKeyCleaned = auth_key.replace(/^"|"$/g, "");


            const data = {
                auth_key: authKeyCleaned,
            };

            const { dispatch } = this.props;
            dispatch(userActions.login(data));
        }
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });

        const data = {
            email: this.state.email.toLowerCase(),
            password: this.state.password
        }


        const { dispatch } = this.props;
        if (this.state.email && this.state.password) {
            dispatch(userActions.login(data));
        }
    }

    render() {
        const { alert } = this.props;

        const { email, password, submitted } = this.state;

        return (
            <div className="login-page text-white">
                <div className="logo1 text-center text-md-left py-3 px-md-5">
                    <img src={logo} alt="OPPTiMiSE" />


                </div>

                <div className=" container pt-5">
                    <div className="d-flex flex-row justify-content-center">
                        <div className="col-lg-5 col-md-8 col-11 px-0">
                            <div className="login-field-page">
                                <p className="h4 text-center py-3 py-lg-2">Login</p>

                                {
                                    alert.message &&
                                    <p className="text-center">Invalid email ID or password</p>
                                }
                                <div className="">
                                    <form
                                        method="post"
                                        onSubmit={
                                            this.handleSubmit
                                        }
                                    >
                                        <div className="form-group">
                                            <label htmlFor="email" className="text-uppercase"><small>EMAIL ID</small></label>
                                            <input
                                                type="email" className="form-control" id="email" placeholder="name@company.com"
                                                name="email"
                                                required
                                                value={email}
                                                onChange={this.handleChange}
                                            />
                                            {
                                                submitted && !email &&
                                                <div className="help-block">Email is required</div>
                                            }
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="inputPassword4" className="text-uppercase"><small>Password</small></label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="inputPassword4"
                                                placeholder="Password"
                                                name="password"
                                                required
                                                value={password}
                                                onChange={this.handleChange}
                                            />
                                            {submitted && !password &&
                                                <div className="help-block">Password is required</div>
                                            }
                                        </div>
                                        <div className="form-group">
                                            <div className="text-center">
                                                <button
                                                    type="submit"
                                                    className="btn buttonColor btn-sm text-white px-4"
                                                >
                                                    <small>ENTER</small>
                                                </button>
                                            </div>
                                        </div>

                                        <p className="text-center "><Link className="text-white" to='/forgot-password'> <small>Forgot Password?</small></Link></p>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>


            </div>
        );
    }
}

function mapStateToProps(state) {

    const { loggingIn } = state.authentication;
    const { alert } = state;
    return {
        loggingIn,
        alert
    };
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export { connectedLoginPage as LoginPage }; 



// WEBPACK FOOTER //
// ./src/_pages/Login/LoginPage.jsx